import React from "react"
import H2 from "../../atoms/typography/H2"
import { Col, Container, Row } from "react-grid-system"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import { TopupPackage } from "../AddDataSection"
import H4 from "../../atoms/typography/H4"
import { Elements } from "@stripe/react-stripe-js"
import { StripeAppPayment, StripePluginPayment } from "../../store/checkout/CheckoutStripePayment"
import { loadStripe } from "@stripe/stripe-js"
import { Metadata } from "../../interfaces/SaleorTypes"
import { STRIPE_PUBLIC_KEY } from "../../../index"
import { IS_USING_STRIPE_PLUGIN_GATEWAY } from "../../../utils/saleor-constants"
import { CheckCircleIcon } from "../../atoms/icons/CheckCircleIcon"
import H1 from "../../atoms/typography/H1"
import { theme } from "../../theme"
import H3 from "../../atoms/typography/H3"
import Body from "../../atoms/typography/Body"

type Props = {
  topupPackage: TopupPackage
  checkoutId: string
  dataPlanId: string | number
  clientSecret: string
}

const ContentWidth = styled.div`
  max-width: 40vw;
  align-items: center;

  ${MediaQuery.XS} {
    max-width: none;
  }
`

const CommonPayTopupModalContent: React.FC<Props & { transactionId?: string }> = ({
  topupPackage,
  checkoutId,
  dataPlanId,
  clientSecret,
  transactionId,
}) => {
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

  const [completedPurchase, setCompletedPurchase] = React.useState(false)

  const options = {
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      variables: {
        fontFamily: ' "Karla", sans-serif',
        fontLineHeight: "1.5",
        colorBackground: "#FFFFFF",
        colorPrimaryText: "#262626",
      },
      rules: {
        ".Block": {
          boxShadow: "none",
          border: "none",
          padding: "12px",
        },
        ".Input": {
          boxShadow: "none",
          padding: "12px",
          border: "2px solid #616161",
          borderTop: "0px",
          borderRight: "0px",
          borderLeft: "0px",
          borderRadius: "0px",
        },
        ".Input:focus": {
          outline: "none",
          border: "2px solid #616161",
          borderTop: "0px",
          borderRight: "0px",
          borderLeft: "0px",
          boxShadow: "none",
        },
        ".Input:disabled, .Input--invalid:disabled": {
          color: "lightgray",
        },
        ".Tab": {
          padding: "10px 12px 8px 12px",
          border: "none",
        },
        ".Tab:hover": {
          border: "none",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
        },
        ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
          border: "none",
          backgroundColor: "#fff",
          boxShadow:
            "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
        },
        ".Label": {
          fontWeight: "500",
        },
      },
    },
  }

  return (
    <Row justify="center">
      {completedPurchase ? (
        <ContentWidth>
          <Row justify="center">
            <CheckCircleIcon />
            <Spacer spacing={1} />
            <H1 color={theme.colors.greenDark}>Thank you for your order!</H1>
          </Row>
          <HorizontalSpacer spacing={2} />
          <H3>Your order:</H3>
          <Body>
            FlexMove topup package of {topupPackage.name} for data plan #{dataPlanId}
          </Body>
          <HorizontalSpacer spacing={2} />
        </ContentWidth>
      ) : (
        <ContentWidth>
          <Col>
            <H2 textAlign="center">Complete purchase</H2>
            <HorizontalSpacer spacing={2} />
            <H4 textAlign="center">
              FlexMove topup package of {topupPackage.name} for data plan #{dataPlanId}
            </H4>
            <HorizontalSpacer spacing={2} />
            <Container>
              <Elements stripe={stripePromise} options={options}>
                {IS_USING_STRIPE_PLUGIN_GATEWAY ? (
                  <StripePluginPayment checkoutId={checkoutId} onClearCart={() => setCompletedPurchase(true)} />
                ) : (
                  <StripeAppPayment
                    checkoutId={checkoutId}
                    onClearCart={() => setCompletedPurchase(true)}
                    transactionId={transactionId!}
                  />
                )}
              </Elements>
            </Container>
            <HorizontalSpacer spacing={1.5} />
          </Col>
        </ContentWidth>
      )}
    </Row>
  )
}

export const PayTopupModalContentStripePlugin: React.FC<Props> = (props) => <CommonPayTopupModalContent {...props} />
export const PayTopupModalContentStripeApp: React.FC<Props & { transactionId: string }> = (props) => (
  <CommonPayTopupModalContent {...props} />
)
